<template>
  <!-- Modal -->
  <div class="modal right fade" id="related_vt" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog modal-lg" role="document">
<!--      <button type="button" class="close md-close" @click="closeWarning('#'+objectModalName.vt)" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
      <div class="modal-content">

        <div class="modal-header">
          <h4 class="modal-title text-center" v-if="currentVT.id === null">Neue Verarbeitungstätigkeit</h4>
          <h4 class="modal-title text-center" v-if="currentVT.id">
            {{ $t('processing_activity') }} {{ $t('edit') }}
          <a href="#" @click.prevent="setEdit(!edit)"><span class="lock"><i class="fa fa-pencil" aria-hidden="true" v-show="!edit"></i><i class="fa fa-lock" aria-hidden="true" v-show="edit"></i></span></a>
          </h4>
          <button type="button" class="close xs-close" data-dismiss="modal" @click="closeWarning('#'+objectModalName.vt)">×</button>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <form>
                <h4>{{ $t('general') }}</h4>
                <div class="form-group row">
                  <div class="col-md-6">
                    <label class="col-form-label">{{ $t('name') }}<span class="text-danger">*</span></label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.name}}</p>
                    <input class="form-control" type="text" name="name" v-show="!currentVT.id || edit" v-model="currentVT.name" autocomplete="off">
                    <span class="error-message text-danger" v-show="v$.currentVT.name.$errors.length>0">{{ $t('required_field') }}</span>
                  </div>
                  <div class="col-md-6">
                    <label class="col-form-label">{{ $t('department') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.departments.join()}}</p>
                    <div v-show="!currentVT.id || edit">
                      <select class="form-control select select-department allow-create select-vt-department" v-model="currentVT.departments" v-select2>
                        <option v-for="department in departments" :key="department.id" :value="department.id">{{department.text}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-6">
                    <label class="col-form-label">{{ $t('description') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.description}}</p>
                    <textarea class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.description" />
                  </div>
                  <div class="col-md-6">
                    <label class="col-form-label">{{ $t('purpose_data_processing') }}<span class="text-danger">*</span></label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.purpose}}</p>
                    <textarea class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.purpose" />
                    <span class="error-message text-danger" v-show="v$.currentVT.purpose.$errors.length>0">{{ $t('required_field') }}</span>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-6">
                    <label class="col-form-label">{{ $t('data_subject') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.affected_person.join()}}</p>
                    <div v-show="!currentVT.id || edit">
                      <select class="form-control select select-affected-person allow-create" v-model="currentVT.affected_person" v-select2>
                        <option v-for="personGroup in personGroups" :key="personGroup.id" :value="personGroup.id">{{personGroup.text}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label class="col-form-label">{{ $t('collected_pd') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.data_type.join()}}</p>
                    <div v-show="!currentVT.id || edit">
                      <select class="form-control select select-data-type allow-create" v-model="currentVT.data_type" v-select2>
                        <option v-for="dataType in dataTypes" :key="dataType.id" :value="dataType.id">{{dataType.text}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-6">
                    <label class="col-form-label">{{ $t('data_type_category') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{dataCategoryDict[currentVT.data_type_category]}}</p>
                    <div v-show="!currentVT.id || edit">
                      <select class="form-control select select-data-type-category select-single" v-model="currentVT.data_type_category" v-select2>
                        <option v-for="dataType in dataTypeCategory" :key="dataType.value" :value="dataType.value">{{dataType.label}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label class="col-form-label">{{ $t('number_of_persons') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.number_of_persons}}</p>
                    <div v-show="!currentVT.id || edit">
                      <select class="form-control select select-number-of-persons select-single" v-model="currentVT.number_of_persons" v-select2>
                        <option v-for="(numberPerson, idx) in numberOfPerson" :key="`numberPerson_${idx}`" :value="numberPerson.value">{{numberPerson.label}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label">{{ $t('process_type') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.process_type}}</p>
                    <textarea class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.process_type" />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-4">
                    <label class="col-form-label">{{ $t('data_origin') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.data_origin}}</p>
                    <textarea class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.data_origin" />
                  </div>
                  <div class="col-md-4">
                    <label class="col-form-label">{{ $t('supplier') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.supplier}}</p>
                    <div  v-show="!currentVT.id || edit">
                      <select class="form-control select select-supplier" v-model="currentVT.suppliers" v-select2>
                        <option v-for="supplier in suppliers" :key="supplier.id" :value="supplier.id">{{supplier.text}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <label class="col-form-label">{{ $t('storage_place') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.storage_place}}</p>
                    <input class="form-control" type="text" v-show="!currentVT.id || edit" v-model="currentVT.storage_place" autocomplete="off">
                  </div>
                </div>
                <h4>{{ $t('other_properties') }}</h4>
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label class="col-form-label">{{ $t('process_place') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.process_place}}</p>
                    <input type="text" class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.process_place" autocomplete="off">
                  </div>
                  <div class="col-sm-6">
                    <label class="col-form-label">{{ $t('system') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.system}}</p>
                    <div  v-show="!currentVT.id || edit">
                      <select class="form-control select select-system" v-model="currentVT.systems" v-select2>
                        <option v-for="system in systems" :key="system.id" :value="system.id">{{system.text}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label class="col-form-label">{{ $t('access_rights') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.access_rights}}</p>
                    <textarea class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.access_rights" />
                  </div>
                  <div class="col-sm-6">
                    <label class="col-form-label">{{ $t('legal_base_requirement') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.legal_base_remarks}}</p>
                    <textarea class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.legal_base_remarks" />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-12">
                    <label class="col-form-label">{{ $t('legal_base.name') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.legal_base}}</p>
                    <div  v-show="!currentVT.id || edit">
                      <select v-select2 v-model="currentVT.legal_base" class="form-control select select-single">
                        <option value="Erfüllung einer rechtlichen Verpflichtung (Art. 6 Abs. 1 lit. c DSGVO)">{{ $t('legal_base.option1') }}</option>
                        <option value="Vertrag oder Vertragsanbahnung (Art. 6 Abs. 1 lit. b DSGVO)">{{ $t('legal_base.option2') }}</option>
                        <option value="Wahrung berechtigter Interessen des Verantwortlichen oder eines Dritten (Art. 6 Abs. 1 lit. f)">{{ $t('legal_base.option3') }}</option>
                        <option value="Einwilligung (Art. 6 Abs. 1 lit. a, Art. 7)">{{ $t('legal_base.option4') }}</option>
                        <option value="Betriebs- oder Einzelvereinbarung">{{ $t('legal_base.option5') }}</option>
                        <option value="Schutz lebenswichtiger Interessen des Betroffenen">{{ $t('legal_base.option6') }}</option>
                        <option value="Wahrung öffentlicher Interessen oder Ausübung öffentlicher Gewalt">{{ $t('legal_base.option7') }}</option>
                        <option value="Einwilligung eines Kindes (Art. 6 Abs. 1 lit. a, Art. 8)">{{ $t('legal_base.option8') }}</option>
                        <option value="Sonstiges">{{ $t('legal_base.option9') }}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label class="col-form-label">{{ $t('intern_receipt') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.intern_receipt}}</p>
                    <input type="text" class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.intern_receipt" autocomplete="off" />
                  </div>
                  <div class="col-sm-6">
                    <label class="col-form-label">{{ $t('extern_receipt') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.extern_receipt}}</p>
                    <input type="text" class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.extern_receipt" autocomplete="off" />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label class="col-form-label">{{ $t('legitimate_interest') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.legitimate_interest}}</p>
                    <textarea class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.legitimate_interest" />
                  </div>
                  <div class="col-sm-6">
                    <label class="col-form-label">{{ $t('affected_interests') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.affected_interests}}</p>
                    <textarea class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.affected_interests" />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label class="col-form-label">{{ $t('interest_balance') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.interest_balance}}</p>
                    <textarea class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.interest_balance" />
                  </div>
                </div>
                <div class="form-group row" style="padding-left: 20px">
                  <div class="col-md-6">
                    <input class="form-check-input" type="checkbox" id="profiling" :disabled="currentVT.id && !edit" v-model="currentVT.profiling" autocomplete="off">
                    <label class="form-check-label" for="profiling">{{ $t('profiling') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.profiling_remarks}}</p>
                    <input type="text" class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.profiling_remarks" autocomplete="off" />
                  </div>
                  <div class="col-md-6">
                    <input class="form-check-input" type="checkbox" id="evaluation"  :disabled="currentVT.id && !edit" v-model="currentVT.evaluation" autocomplete="off">
                    <label class="form-check-label" for="evaluation">{{ $t('evaluation') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.evaluation_remarks}}</p>
                    <input type="text" class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.evaluation_remarks" autocomplete="off" />
                  </div>
                </div>
                <div class="form-group row" style="padding-left: 20px">
                  <div class="col-md-6">
                    <input class="form-check-input" type="checkbox" id="person_informed" :disabled="currentVT.id && !edit" v-model="currentVT.person_informed" autocomplete="off">
                    <label class="form-check-label" for="person_informed">
                      {{ $t('person_informed') }}
                    </label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.person_informed_remarks}}</p>
                    <input type="text" class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.person_informed_remarks"  autocomplete="off"/>
                  </div>
                  <div class="col-md-6">
                    <input type="checkbox" id="data_transfer" class="form-check-input" :disabled="currentVT.id && !edit" v-model="currentVT.data_transfer" autocomplete="off" />
                    <label class="form-check-label" for="person_informed">
                      {{ $t('data_transfer') }}
                    </label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.data_transfer_remarks}}</p>
                    <input type="text" class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.data_transfer_remarks" autocomplete="off" />
                  </div>
                </div>

                <h4>{{ $t('data_storage') }}</h4>
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label class="col-form-label">{{ $t('storage_duration') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.storage_duration}}</p>
                    <textarea class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.storage_duration" />
                  </div>
                  <div class="col-sm-6">
                    <label class="col-form-label">{{ $t('storage_should') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.storage_should}}</p>
                    <textarea class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.storage_should" />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label class="col-form-label">{{ $t('reason_extended_storage') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.reason_extended_storage}}</p>
                    <textarea class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.reason_extended_storage" />
                  </div>
                  <div class="col-sm-6">
                    <label class="col-form-label">{{ $t('storage_legal_base') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.storage_legal_base}}</p>
                    <textarea class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.storage_legal_base" />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label class="col-form-label">{{ $t('delete_method') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.delete_method}}</p>
                    <textarea class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.delete_method" />
                  </div>
                  <div class="col-sm-6">
                    <label class="col-form-label">{{ $t('delete_department') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.delete_department}}</p>
                    <textarea class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.delete_department" />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label class="col-form-label">{{ $t('delete_process') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.delete_process}}</p>
                    <textarea class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.delete_process" />
                  </div>
                </div>
                <h4>{{ $t('menu.risk_assessment') }}</h4>
                <div class="form-group row">
                  <div class="col-md-6">
                    <label class="col-form-label">{{ $t('risk_level') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{ currentVT.risk_level ? RISKLEVEL[currentVT.risk_level] : '' }}</p>
                    <div v-show="!currentVT.id || edit">
                      <select class="form-control select select-risk-level select-single" v-model="currentVT.risk_level" v-select2>
                        <option value="normal">{{ $t('risk_level_option.normal') }}</option>
                        <option value="high">{{ $t('risk_level_option.high') }}</option>
                        <option value="very high">{{ $t('risk_level_option.very_high') }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label class="col-form-label">{{ $t('risk_level_remarks') }}</label>
                    <p class="mt-0" v-if="currentVT.id && !edit">{{currentVT.risk_remarks}}</p>
                    <textarea class="form-control" v-show="!currentVT.id || edit" v-model="currentVT.risk_remarks" />
                  </div>
                </div>
                <div class="form-control row">
                  <div class="col-md-12" style="margin-left: 20px;">
                    <input class="form-check-input" type="checkbox" id="dsfa" :disabled="currentVT.id && !edit" v-model="currentVT.dsfa" autocomplete="off">
                    <label class="form-check-label" for="dsfa">
                      {{ $t('assessment_necessary') }}
                    </label>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-6">
                    <div><a class="editor-new-risk btn btn-outline-info" :data-vt-id="currentVT.id" href="#" @click.prevent="emitRiskAnalysis('completeRiskAnalysis', currentVT.id)">{{ $t('complete_risk_assessment') }}</a></div>
                  </div>
                  <div class="col-sm-6">
                    <div><a class="editor-simple-risk btn btn-outline-secondary" :data-vt-id="currentVT.id" href="#" @click.prevent="emitRiskAnalysis('simpleRiskAnalysis', currentVT.id)">{{ $t('simple_risk_assessment') }}</a></div>
                  </div>
                </div>
                <!-- start attachments -->
                <slot name="fileUpload"></slot>
                <!-- end attachments -->
                <!-- comments -->
                <slot name="comments"></slot>
                <!-- end comments -->
              </form>
            </div>
          </div>

        </div>

        <div class="modal-footer">
          <div class="text-center py-3">
            <button type="button" class="border-0 btn btn-primary btn-gradient-primary btn-rounded" v-show="!currentVT.id || edit" @click.prevent="saveVT" :key="btnEnableKey" :disabled="btnDisabled">{{ $t('save') }}</button>&nbsp;&nbsp;
            <button type="button" @click="closeWarning('#'+objectModalName.vt)" aria-label="Close" class="btn btn-secondary btn-rounded">
              {{ $t('close') }}</button>
          </div>
        </div>

      </div><!-- modal-content -->
    </div><!-- modal-dialog -->
  </div><!-- modal -->
  <!--Deal details Modal -->
</template>

<script>
import {service} from '@/utils/request.js';
import {initSelect2, boolDisplay, closeWarning, ajaxErrorMessage} from '@/utils/index.js';
import {dataTypeCategory, newVT, numberOfPerson, objectModalName, RISKLEVEL} from '@/utils/enums';
import {mapState, mapMutations} from 'vuex';
import datePicker from 'vue-bootstrap-datetimepicker';
import { Uploader, Button } from 'vant';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
  name: "VTComponent",
  components: {'van-uploader': Uploader, 'van-button': Button, datePicker},
  props: {
    currentVT: {
      type: Object,
      default: () => {
        return newVT
      },
    },
    editVT: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      datetimeOptions: {
        format: 'YYYY-MM-DD',
        useCurrent: false,
      },
      boolDisplay: boolDisplay,
      objectModalName: objectModalName,
      btnEnableKey: 1,
      btnDisabled: false,
      dataTypeCategory: dataTypeCategory,
      numberOfPerson: numberOfPerson,
      RISKLEVEL: RISKLEVEL,
    }
  },
  validations() {
    return {
      currentVT: {
        name: {required, $lazy: true},
        purpose: {required, $lazy: true}
      },
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  watch:{
    currentVT: {
      handler: function (newValue, oldVal) {
        if (!this.modalDirty) this.setModalDirty(true)
      },
      deep: true
    }
  },
  async mounted() {
    initSelect2()
    $('#related_vt').on('hidden.bs.modal', () => {
      this.setEdit(false)
    })
    $('#related_vt').on('shown.bs.modal', () => {
      $('#related_vt .select-department').val(this.currentVT.departments).trigger('change')
      $('#related_vt .select-affected-person').val(this.currentVT.affected_person).trigger('change')
      $('#related_vt .select-data-type').val(this.currentVT.data_type).trigger('change')
      $('#related_vt .select-system').val(this.currentVT.systems).trigger('change')
      $('#related_vt .select-supplier').val(this.currentVT.suppliers).trigger('change')
      $('#related_vt .select-data-type-category').val(this.currentVT.data_type_category).trigger('change')
      $('#related_vt .select-number-of-persons').val(this.currentVT.number_of_persons).trigger('change')
      $('#related_vt .select-risk-level').val(this.currentVT.risk_level).trigger('change')
    })
  },
  beforeDestroy() {
    $('#related_vt').off('shown.bs.modal')
    $('#related_vt').off('hidden.bs.modal')
  },
  computed: {
    ...mapState({
      accountid: state => state.account.accountid,
      userName: state => state.user.username,
      account: state => state.account,
      userID: state => state.user.id,
      departments: state => state.account.departments,
      systems: state => state.account.systems,
      suppliers: state => state.account.suppliers,
      personGroups: state => state.account.personGroups,
      dataTypes: state => state.account.dataTypes,
      edit: state => state.app.edit,
      modalDirty: state => state.app.modalDirty,
    }),
    dataCategoryDict() {
      return dataTypeCategory.reduce((acc, item) => {
        acc[item.value] = item.label
        return acc
      }, {})
    },
  },
  methods: {
    closeWarning,
    ...mapMutations({
      setDepartments: 'SET_DEPARTMENTS',
      setPersonGroups: 'SET_PERSONGROUPS',
      setSystems: 'SET_SYSTEMS',
      setEdit: 'SET_EDIT',
      setModalDirty: 'SET_MODALDIRTY'
    }),
    emitRiskAnalysis(riskName, vtID) {
      if (!vtID) {
        this.$vToastify.error('Die neue VT muss zuerst gespeichert werden!')
        return null
      }
      this.$emit(riskName, vtID)
    },
    async saveVT() {
      const isValid = await this.v$.currentVT.$validate()
      if (!isValid) {
        this.$vToastify.error('Bitte fehlende Felder vervollständigen!')
        return
      }
      this.btnDisabled = true
      this.currentVT.modified_by = this.userName
      let isCreating = false
      let url = `todos/v1/save_vt/${this.currentVT.id}/`
      let method = 'PUT'
      if (this.currentVT.id === null) {
        isCreating = true
        url = 'todos/v1/save_vt/'
        method = 'POST'
      }
      service.request({
        url: url,
        method: method,
        responseType: 'json',
        data: this.currentVT
      }).then((response) => {
        // if (!response.data.departments.some(item => that.departments.some(department => department.text === item))) that.updateDepartments(response.data.departments)
        this.btnDisabled = false
        this.setModalDirty(false)
        this.v$.$reset()
        this.$emit('vtUpdated', response.data)
        $('#' + objectModalName.vt).modal('hide')
        this.$vToastify.success('VT ist erfolgreich gespeichert!')
      }).catch(error => {
        this.btnDisabled = false
        this.$vToastify.error(ajaxErrorMessage(error))
      })
    },
  }
}
</script>

<style scoped>
.close {
  right: 25px;
  top: 20px;
}

</style>
